import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, switchMap } from 'rxjs';
import {
  PublicBrandDataSourceService,
  PublicBrandDetails,
} from '@web/shared/module/brand';
import { Icon, SpinnerFilledComponent } from '@web/shared/ui';
import { BrandDetailsComponent } from '../../../shared/components/brand-details/brand-details.component';
import { PublicBrandBannerCarouselComponent } from '../public-brand-banner-carousel/public-brand-banner-carousel.component';

@Component({
  selector: 'app-public-brand-details',
  imports: [
    CommonModule,
    BrandDetailsComponent,
    PublicBrandBannerCarouselComponent,
    SpinnerFilledComponent,
  ],
  templateUrl: './public-brand-details.component.html',
  styleUrl: './public-brand-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBrandDetailsComponent {
  private readonly publicBrandDataSource = inject(PublicBrandDataSourceService);

  public readonly slug = input.required<string>();

  protected readonly slug$ = toObservable(this.slug);
  protected readonly details$ = this.detailsSource();
  protected readonly Icon = Icon;

  private detailsSource(): Observable<PublicBrandDetails> {
    return this.slug$.pipe(
      switchMap((slug) => this.publicBrandDataSource.fetchDetailsBySlug(slug)),
    );
  }
}
